import Icons from '@/icons/index'

const KNOWN_SIDEBAR_ICONS = new Set(Icons.getNameList())

/**
 * 侧栏 icon 依 enName 映射（对应 src/icons/svg/*.svg 文件名，不含 .svg）。
 */
export const SIDEBAR_ICON_BY_EN_NAME = {
  configProfileLibrary: 'soc-files',
  coffeeMachineChannelSlots: 'soc-config',
  configBindDispatch: 'bind',
  simulatorGroup: 'soc-sim',
  x600hGateway: 'link',
  xt90c2Simulator: 'soc-sim',
  blenderSimulator: 'soc-sim',
  xosIviSimulator: 'soc-sim',
  hansonIviSimulator: 'soc-sim',
  deviceLinkDebug: 'link',
  x600hProductionOrder: 'soc-rd',
  leoKnowledgeGroup: 'leo-group',
  leoKnowledgeModelFields: 'leo-model-fields',
  leoKnowledgeEquipmentTypeTypeKey: 'leo-type-key',
  leoKnowledgeUpload: 'leo-upload',
  leoKnowledgeIngestBatch: 'leo-batch',
  leoKnowledgePhase1Ssot: 'leo-ssot',
  leoKnowledgeCapabilityMatrix: 'leo-matrix',
  leoKnowledgeOnboarding: 'leo-onboard',
  leoKnowledgeTesterConsole: 'leo-tester',
  leoKnowledgePipelineHub: 'leo-pipeline',
  leoKnowledgeFeatureSurface: 'leo-api-map',
  leoKnowledgeProtocolDoc: 'leo-doc',
  leoKnowledgeRemoteTools: 'leo-remote',
  leoKnowledgeLearning: 'leo-learn',
  leoKnowledgeExternalIngest: 'leo-external',
  leoKnowledgePortalHub: 'leo-portal-hub',
  leoKnowledgeUiSurfaceSample: 'theme',
  leoDeviceOpsRolePolicy: 'leo-policy',
  leoDeviceOpsSemanticTraining: 'leo-semantic',
  leoProductionE2eTraining: 'leo-t6',
  leoTrainingDashboard: 'leo-train',
  leoT2GoldenTraining: 'leo-golden',
  leoT9DeepseekTraining: 'leo-deepseek',
  leoTurnRoutingTrainingHub: 'leo-route',
  leoCommandOnboardingWizard: 'leo-wizard',
  leoKnowledgePortalOpsInventory: 'leo-inventory',
  leoKnowledgePortalOpsDailyHub: 'leo-b-line',
  leoDeviceOpsReviewInbox: 'leo-review',
  leoDeviceOpsDescriptionAutogen: 'leo-inventory',
  leoDeviceOpsBLineDailyHub: 'leo-b-line',
  leoDeviceOpsBundleCandidates: 'leo-bundle',
  leoXeeGrowthDashboard: 'leo-growth',
  leoIntelligenceGrowthDashboard: 'leo-growth',
  leoTrainingDecisionDesk: 'leo-desk',
  leoTrainingFederationCommandCenter: 'leo-federation',
  leoTrainingFederationCases: 'leo-federation',
  leoClawPlanCapabilityHub: 'leo-claw',
  leoTasteHabitPerception: 'leo-taste',
  leoKnowledgeFolderPortal: 'leo-folder-portal',
  leoKnowledgeFolderModel: 'leo-folder-model',
  leoKnowledgeFolderIngest: 'leo-folder-ingest',
  leoKnowledgeFolderProtocol: 'leo-folder-protocol',
  leoKnowledgeFolderOps: 'leo-folder-ops',
  // E1／设备智能：专用样稿 SVG（src/icons/svg/leo-e1-*.svg）
  leoKnowledgeFolderDeviceIntel: 'leo-e1-device',
  leoE1Overview: 'leo-e1-overview',
  leoE1Components: 'leo-e1-parts',
  leoE1Production: 'leo-e1-production',
  leoE1Proposals: 'leo-e1-inbox',
  leoE1Health: 'leo-e1-health',
  leoE1Impact: 'leo-e1-impact',
  leoE1Policy: 'leo-e1-policy',
  leoE1TargetQuality: 'leo-e1-target',
  leoE1Curves: 'leo-e1-curves',
  leoE1Peer: 'leo-e1-peer',
  leoE1LifeGate: 'leo-e1-life',
  memberHqGroup: 'soc-member',
  memberHqDashboard: 'soc-display',
  memberHqFinance: 'soc-business',
  memberHqOps: 'soc-maintenance',
  distributorReportGroup: 'soc-data',
  distributorDashboard: 'soc-display',
  distributorMembers: 'soc-member',
  distributorProfit: 'soc-business',
  homePage: 'soc-home',
  dataDisplay: 'soc-display',
  atlas: 'soc-atlas',
  journal: 'soc-journal',
  details: 'eye',
  systemSetting: 'soc-system',
  loginAccount: 'user',
  authorization: 'role',
  merchants: 'soc-merchants',
  devices: 'soc-devices',
  material: 'soc-material',
  deviceConfig: 'soc-config',
  channelConfiguration: 'link',
  productCenter: 'soc-product',
  productCenterFolderBasic: 'list',
  productCenterFolderProducts: 'soc-product',
  productCenterFolderMenu: 'nested',
  productCenterFolderChannels: 'bind',
  productCenterFolderAddons: 'soc-material',
  productCenterFolderOther: 'component',
  dataCenter: 'soc-data',
  maintenance: 'soc-maintenance',
  filesCenter: 'soc-files',
  menuSetting: 'list',
  organization: 'soc-org',
  deviceList: 'soc-devices',
  channelCategory: 'tab',
  productCategory: 'component',
  optionCategory: 'size',
  optionList: 'list',
  storeAccount: 'account',
  stores: 'online',
  modelName: 'soc-devices',
  category: 'soc-material',
  configDistribute: 'bind',
  devicesChannels: 'link',
  productsList5: 'list',
  posCenter: 'soc-pos',
  produceFivePos: 'soc-pos',
  menuDistribute: 'nested',
  storeMenu: 'list',
  merchantsData: 'soc-data',
  merchantData: 'soc-data',
  devicsData: 'soc-data',
  productionData: 'soc-data',
  maintanenceData: 'soc-maintenance',
  devicesWorkingData: 'soc-data',
  afterSalesReminder: 'message',
  maintenanceTips: 'clipboard',
  fileUpgrade: 'software-upgrade',
  dataDowloan: 'download',
  materialList: 'list',
  accessoriesCategory: 'component',
  accessoriesList: 'list',
  businessCenter: 'soc-business',
  appsBanner: 'message',
  advertisement: 'eye',
  advertBind: 'link',
  advertDistribute: 'upload',
  membersCenter: 'soc-member',
  orderCenter: 'amount',
  packBag: 'paper-cup',
  appsCenter: 'soc-apps',
  productsList2: 'list',
  XTSeriesData: 'soc-data',
  materialDate: 'soc-material',
  qualityData: 'soc-data',
  alertsLog: 'offline',
  cleaningLog: 'refresh',
  coffeeData: 'paper-cup',
  coffeeMachineProductionData: 'soc-data',
  coffeeMachineSingleCupData: 'maintain',
  coffeeSumData: 'soc-data',
  taxCenter: 'soc-tax',
  taxManagement: 'soc-tax',
  taxAllocation: 'amount',
  dataOfTeaExtractorMachine: 'soc-data',
  teaSingleCupParams: 'soc-data',
  dataOfBlendExtractorMachine: 'soc-data',
  dataOfMilkExtractorMachine: 'soc-data',
  beverageOutputData: 'soc-data',
  singleCupData: 'soc-data',
  faultLog: 'offline',
  deliveryPlatform: 'soc-delivery',
  uber: 'soc-delivery',
  otherProducts: 'tab',
  listOfTeaExtractsProducts: 'list',
  deviceRdGroup: 'soc-rd',
  machineDebug: 'soc-rd',
  presetCommand: 'edit',
  commandConfiguration: 'component',
  operationAndMaintenanceServices: 'workOrder',
  productionList: 'list',
  smallMaterial: 'soc-material',
  takeoutProducts: 'paper-cup',
  pointRule: 'star',
  couponManagement: 'money',
  couponList: 'list',
  additionalProducts: 'tab',
  type: 'size',
  produce: 'component',
  produceList4: 'list',
  smoothieMakerProduct: 'paper-cup',
  machineMenu: 'list',
  systemLog: 'message',
  region: 'soc-org',
  menuNav: 'nested',
  merchantTokenBillingPlatform: 'soc-business',
  merchantDataBillingPlatform: 'soc-business',
  linuxAutoOps: 'soc-devices',
  linuxAutoEquipment: 'soc-devices',
  linuxAutoRemoteOps: 'soc-maintenance',
  linuxAutoProfileConfig: 'soc-files',
  linuxAutoDataBilling: 'soc-business',
  linuxAutoModelRegistry: 'list',
  linuxAutoPartnerDelivery: 'guide',
  linuxAutoFleetMonitor: 'soc-data',
  linuxAutoCanAutoMatch: 'link',
  linuxAutoDbcEntitlement: 'soc-business',
  linuxAutoCabinFeatures: 'component',
  equipmentCategory: 'soc-devices',
  produceData: 'soc-data'
}

/** 专用品牌图标：leo-e1-*／leo-*／soc-* 优先于 DB 旧通用名 */
export function isBrandedSidebarIcon (icon) {
  return /^(leo-e1-|leo-|soc-)/.test(icon || '')
}

function isLegacyElementIcon (icon) {
  return /^el-icon-/i.test(icon) || /^el-icon$/i.test(icon)
}

function isValidSidebarIcon (icon) {
  return icon && KNOWN_SIDEBAR_ICONS.has(icon) && !isLegacyElementIcon(icon)
}

/**
 * 解析单条侧栏菜单应展示的 SVG 图标名。
 */
export function resolveSidebarMenuIcon (menu) {
  if (!menu) return 'list'
  const hasChildren = Array.isArray(menu.menuList) && menu.menuList.length > 0
  const en = menu.enName != null ? String(menu.enName).trim() : ''
  const raw = menu.icon != null ? String(menu.icon).trim() : ''
  const mapped = en ? SIDEBAR_ICON_BY_EN_NAME[en] : ''
  // 已登记的专用样稿优先（避免 DB 仍写 list/chart 时压住新图标）
  if (isBrandedSidebarIcon(mapped) && isValidSidebarIcon(mapped)) return mapped
  if (isValidSidebarIcon(raw)) return raw
  if (isValidSidebarIcon(mapped)) return mapped
  return hasChildren ? 'nested' : 'list'
}

/** 递归补齐侧栏树 icon（空值、Element 旧图标、未注册 SVG 名均会修正）。 */
export function fillSidebarMenuIcons (nodes) {
  if (!Array.isArray(nodes)) return
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (Array.isArray(n.menuList) && n.menuList.length) {
      fillSidebarMenuIcons(n.menuList)
    }
    n.icon = resolveSidebarMenuIcon(n)
  }
}



// WEBPACK FOOTER //
// ./src/utils/sidebarMenuIcons.js